import { Component, Input, OnDestroy, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { LoadingIndicatorService, ToastrService } from '@kpmg-tax/ui';
import { combineLatest, Subscription, tap } from 'rxjs';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { Study } from 'src/app/home/models/study.model';
import { SurveyDocument, TimeSurveyDocument } from 'src/app/survey/models/survey-document.model';
import { APP_CONSTANTS, File_TYPE } from '../constants/app-constants';
import { role } from '../constants/role-enum';
import { FileService } from '../file-service/file.service';
import { RightSideDrawerService } from '../right-side-drawer/right-side-drawer.service';
import { ExpenseSurveyDocumentService } from '../survey-document/services/expense-survey-document.service';
import { TimeSurveyDocumentService } from '../survey-document/services/time-survey-document.service';
import { SurveyDocumentComponent } from '../survey-document/survey-document.component';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { ProjectSurveyDetailsService } from '../../survey/project-survey-details/project-survey-details.service';
import { DefineProjectsService } from 'src/app/data-analysis-summary/define-projects/define-projects.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Project } from '../models/project.model';
import { AdminClientUsersService } from 'src/app/admin/admin-client-users/admin-client-users.service';
import { FileTypeEnum } from 'src/app/shared/constants/file-type.enum';
import { ImpersonationService } from '../impersonation/impersonation.service';
import { SessionService } from '../session-service/session.service';
import { ClientManagerSurveyListService } from '../../survey/client-manager-survey-list/client-manager-survey-list.service';
import { ProjectSurvey } from '../models/project-survey';
import { CustomDropDown } from '../models/custom-dropdown.model';
import { BaseResponse } from '../models/base-response.model';
import { BusinessComponentService } from 'src/app/data-analysis-summary/business-component/business-component.service';
import { CommonService } from '../common/common-service';
const ZERO = 0;

@Component({
    selector: 'custom-uploader',
    templateUrl: './custom-uploader.component.html',
    styleUrls: ['./custom-uploader.component.scss']
})

export class CustomUploaderComponent implements OnInit, OnDestroy {
    @Input() uploadData!: any;
    @Input() uploaderTitle!: string;
    @Input() uploadedFileName!: string;
    @Input() uploadedFileType!: number;
    @Input() allowedFileType!: string;
    @Input() surveyCategory: number;
    @Input() hideUploadSection: boolean = true;
    @ViewChild('fileUploader') fileUploader;
    @ViewChild(SurveyDocumentComponent) private expenseSurveyUpload!: SurveyDocumentComponent;
    @Output() drawerWidth = new EventEmitter<any>();
    showTemplate = false;
    showConfirmationBox = false;
    uploadedFile: File;
    fileName = '';
    study: Study = {} as Study;
    showUploadedFiles = false;
    expenseSurveyUploadedDocuments: SurveyDocument[] = [];
    surveyId = ZERO;
    clientId = ZERO;
    timeSurveyUploadedDocuments: TimeSurveyDocument[];
    uploadedDocuments: SurveyDocument[] | TimeSurveyDocument[];
    subscriptions: Subscription[] = [];
    isValidFile = false;
    public isUploadDisabled = true;
    hideUpload = false;
    public isClientManager = false;
    progress: number = 0;
    uploadFailed: boolean = false;
    projectSurveyUploadedDocuments: SurveyDocument[] = [];
    showprogressbar = false;
    tagProjectIds: string;
    dropdownSettings: IDropdownSettings = {};
    surveyDropdownSettings: IDropdownSettings = {};
    dropdownList: Project[] = [];
    surveyDropdownList: CustomDropDown[] = [];
    selectedTagProjectList: Project[] = [];
    selectedTagProjects: number[] = [];
    isFromManageClientUserDrawer: boolean = false;
    fileTypeEnum: typeof FileTypeEnum = FileTypeEnum;
    showFileImportSection: boolean = false;
    userId: string;
    uploadDescription = '';
    showBCUploadConfirmDialog = false;
    importFromRCN: boolean = true;

    constructor(
        private _fileService: FileService,
        private _drawerService: RightSideDrawerService,
        private _toastrService: ToastrService,
        private _loader: LoadingIndicatorService,
        private _expenseSurveyDocumentService: ExpenseSurveyDocumentService,
        private _defineProjectsService: DefineProjectsService,
        private _surveyDocumentService: TimeSurveyDocumentService,
        private _userDataService: UserDataService,
        private _projectSurveyDetailsService: ProjectSurveyDetailsService,
        private _adminClientUsersService: AdminClientUsersService,
        private _impersonationService: ImpersonationService,
        private _sessionService: SessionService,
        private _clientManagerSurveyListService: ClientManagerSurveyListService,
        private _businessComponentService: BusinessComponentService,
        private _commonService: CommonService
    ) { }

    ngOnInit(): void {
        const engagementInfo = this._commonService.engagementInfo;
        if(engagementInfo){
            this.importFromRCN = engagementInfo.workflowId === null || engagementInfo.workflowId == 0;
        }

        this.study.engagementId = (this.uploadData?.studyId != 0 && this.uploadData?.studyId != null && this.uploadData?.studyId != undefined) ?
            Number(this.uploadData?.studyId) : Number(this._sessionService.getSession('engagementId'));
        this.surveyId = this.uploadData?.surveyId ? Number(this.uploadData?.surveyId) : ZERO;
        this.showTemplate = this.uploaderTitle === APP_CONSTANTS.UPLOAD_PAYROLL ||
            this.uploaderTitle === APP_CONSTANTS.UPLOAD_PROJECTS ||
            this.uploaderTitle === APP_CONSTANTS.IMPORT_TIME_TRACKING ||
            this.uploaderTitle === APP_CONSTANTS.ADD_MULTIPLE_USERS ||
            this.uploaderTitle === APP_CONSTANTS.BUSINESS_COMPONENTS ? true : false;
        this.showUploadedFiles = this.uploaderTitle === APP_CONSTANTS.UPLOAD_EXPENSE_SURVEY_DOCUMENT ||
            this.uploaderTitle === APP_CONSTANTS.UPLOAD_TIME_SURVEY_DOCUMENT(this.uploadData?.employeeName) ||
            this.uploaderTitle === APP_CONSTANTS.VIEW_TIME_SURVEY_DOCUMENT(this.uploadData?.employeeName) ||
            this.uploaderTitle === APP_CONSTANTS.UPLOAD_PROJECT_SURVEY_DOCUMENT ||
            this.uploaderTitle === APP_CONSTANTS.VIEW_PROJECT_SURVEY_DOCUMENT ||
            this.uploaderTitle === APP_CONSTANTS.VIEW_EXPENSE_SURVEY_DOCUMENT ? true : false;

        this.isFromManageClientUserDrawer = this._drawerService?.manageClientUserData ?
            this._drawerService.manageClientUserData.isManageClientUser : false;


        this.subscriptions.push(this._expenseSurveyDocumentService.surveyDocument$.subscribe(surveyDocuments => {
            if (surveyDocuments) {
                this.expenseSurveyUploadedDocuments = surveyDocuments;
            }
        }));

        this.subscriptions.push(this._surveyDocumentService.surveyDocument$.subscribe(surveyDocuments => {
            if (surveyDocuments) {
                this.timeSurveyUploadedDocuments = surveyDocuments;
            }
        }));
        this.subscriptions.push(this._projectSurveyDetailsService.surveyDocument$.subscribe(surveyDocuments => {
            if (surveyDocuments) {
                this.projectSurveyUploadedDocuments = surveyDocuments;
            } else {
                this.projectSurveyUploadedDocuments = [];
            }
        }));
        this.subscriptions.push(this._userDataService.userDetails$.subscribe(userView => {
            if (userView) {
                this.isClientManager = userView.roleId === role.clientManager;
                this.userId = userView.userId.toString();
            }
        }));

        this.checkUserRoleView();

         this.showDocumentsOnUplader();
        if (this.uploaderTitle === APP_CONSTANTS.UPLOAD_PAYROLL || this.uploaderTitle === APP_CONSTANTS.UPLOAD_PROJECTS || this.uploaderTitle === APP_CONSTANTS.ADD_MULTIPLE_USERS || this.uploaderTitle === APP_CONSTANTS.BUSINESS_COMPONENTS
        ) {
            this.drawerWidth.emit("calc(81vw - 100px)");
        } else {
            this.drawerWidth.emit("calc(46vw - 100px)");
        }
        if (this.uploaderTitle !== APP_CONSTANTS.UPLOAD_RELEASE_NOTES && this.uploaderTitle !== APP_CONSTANTS.UPLOAD_RELEASE_HISTORY) {
            this._defineProjectsService.getProjectNames(this.study.engagementId, (this.uploadedFileType === this.fileTypeEnum.ExpenseSurvey || this.isClientManager ? 1 : 0)).subscribe((data: Project[]) => {
                this.dropdownList = data;
            });
        }
        if (this.uploaderTitle == APP_CONSTANTS.MANAGE_FILES) {
            if (this.isClientManager) {
                this._surveyDocumentService.getSurveysOnlyByEngagement(this.study.engagementId).subscribe((data: BaseResponse) => {
                    if (data.success) {
                        if (data.result.length > 0) {
                            var options: CustomDropDown[] = [];
                            data.result.forEach((item) => {
                                options.push({ id: item.surveyId, value: item.surveyName, isDisabled: false });
                            });
                            this.surveyDropdownList = options;
                        }
                    }
                })
            } else {
                this._clientManagerSurveyListService.getSMESurvey(this.userId).subscribe((data: BaseResponse) => {
                    if (data.success) {
                        if (data.result.length > 0) {
                            var options: CustomDropDown[] = [];
                            data.result.forEach((item) => {
                                options.push({ id: item.surveyId, value: item.surveyName, isDisabled: false });
                            });
                            this.surveyDropdownList = options;
                        }
                    }
                })
            }
        }


        this.dropdownSettings = {
            singleSelection: false,
            defaultOpen: false,
            idField: 'projectId',
            textField: 'name',
            enableCheckAll: false,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
        };

        this.surveyDropdownSettings = {
            singleSelection: true,
            defaultOpen: false,
            idField: 'id',
            textField: 'value',
            enableCheckAll: false
        };
    }

    checkUserRoleView() {
        combineLatest([
            this._userDataService.userDetails$,
            this._impersonationService.clientManagerModeActive$
        ]).subscribe(([userData, isClientManagerModeActive]) => {
            if (userData && userData.roleId > 0 &&
                userData.roleId === role.clientManager) {
                this.hideUpload = true;
            } else if (isClientManagerModeActive) {
                this.hideUpload = true;
            } else {
                this.hideUpload = false;
            }
        });
    }

    showDocumentsOnUplader() {
        if (this.uploaderTitle === APP_CONSTANTS.UPLOAD_EXPENSE_SURVEY_DOCUMENT ||
            this.uploaderTitle === APP_CONSTANTS.VIEW_EXPENSE_SURVEY_DOCUMENT) {
            this.uploadedDocuments = this.expenseSurveyUploadedDocuments;
        } else if (this.uploaderTitle === APP_CONSTANTS.UPLOAD_TIME_SURVEY_DOCUMENT(this.uploadData?.employeeName) ||
            this.uploaderTitle === APP_CONSTANTS.VIEW_TIME_SURVEY_DOCUMENT(this.uploadData?.employeeName)) {
            this.uploadedDocuments = this.timeSurveyUploadedDocuments
        } else if (this.uploaderTitle === APP_CONSTANTS.UPLOAD_PROJECT_SURVEY_DOCUMENT ||
            this.uploaderTitle === APP_CONSTANTS.VIEW_PROJECT_SURVEY_DOCUMENT) {
            this.uploadedDocuments = this.projectSurveyUploadedDocuments;
        } else {
            this.uploadedDocuments = [];
        }
    }

    onFileUpload(): void {
        this.isUploadDisabled = false;
        this.showprogressbar = false;
        this.uploadedFile = this.fileUploader.nativeElement.files[ZERO];
        this.isValidFile = this.validateFileType();
        if (!this.isValidFile) {
            this._toastrService.setErrorMessage(APP_CONSTANTS.FILE_NOT_SUPPORTED);
        } else {
            this.uploadFailed = false;
        }
    }

    validateFileType(): boolean {
        const uploadedFileType = this.uploadedFile.name.substring(this.uploadedFile.name.lastIndexOf('.'));
        if (APP_CONSTANTS.FILE_UPLOAD_TYPES.some(item => item.toLowerCase().trim() === uploadedFileType)) {
            return true;
        }
        else {
            return false;
        }
    }

    deleteFile(): void {
        this.progress = 0;
        this.isValidFile = false;
        this.uploadedFile = null;
    }

    getFileDtoRequest(): FormData {
        const formData: FormData = new FormData();
        formData.append('EngagementId', this.study.engagementId.toString());
        formData.append('DataFile', this.uploadedFile);
        formData.append('InsertedOn', new Date().toDateString());
        formData.append('FileType', this.uploadedFileType.toString());
        formData.append('SurveyId', this.surveyId.toString());
        formData.append('SurveyType', this.uploadData.surveyType ? this.uploadData.surveyType : 0);
        formData.append('ClientId', this.uploadData && this.uploadData.clientId ? this.uploadData.clientId.toString() : ZERO.toString());
        if (!this.isClientManager) {
            formData.append('UploadDescription', this.expenseSurveyUpload && this.expenseSurveyUpload.uploadDescription ?
                this.expenseSurveyUpload.uploadDescription : '');
        }
        else {
            formData.append('UploadDescription', this.uploadDescription ?
                this.uploadDescription : '');
        }
        formData.append('TagProjectIds', this.selectedTagProjects ? this.selectedTagProjects.toString() : '0');
        formData.append('EmployeeId', this.uploadData && this.uploadData.employeeId ?
            this.uploadData.employeeId.toString() : ZERO.toString());
        return formData;
    }

    onItemSelect(item: Project) {
        if (!this.selectedTagProjectList.some(x => x.projectId == item.projectId)) {
            this.selectedTagProjectList.push(item);
        };
        this.getSelectedProjects();
    }

    onItemDeSelect(item: Project) {
        this.selectedTagProjectList = this.selectedTagProjectList.filter(x => x.projectId !== item.projectId);
        this.selectedTagProjects = [];
        this.getSelectedProjects();
    }

    getSelectedProjects() {
        this.selectedTagProjectList.forEach(x => {
            const isvalueExists = this.selectedTagProjects.includes(x.projectId);
            if (!isvalueExists) {
                this.selectedTagProjects.push(x.projectId);
            }
        })
    }

    uploadFile(): void {
        if (this.uploadedFileType === File_TYPE.BUSINESS_COMPONENT) {
            if (this.uploadData?.hasBusinessComponents) {
                this.showBCUploadConfirmDialog = true;
            } else {
                this.importBCUpload();
            }
        } else {
            this.isUploadDisabled = true;
            this.showprogressbar = true;
            this._drawerService.spinnerLoad(true);
            const fileUploadRequest = this.getFileDtoRequest();
            this._fileService.uploadFile(fileUploadRequest).subscribe((event: HttpEvent<any>) => {
                switch (event.type) {
                    case HttpEventType.Sent:
                        break;
                    case HttpEventType.ResponseHeader:
                        this.uploadResponse(event.status);
                        break;
                    case HttpEventType.UploadProgress:
                        this.progress = Math.round(event.loaded / event.total * 100);
                        break;
                    case HttpEventType.Response:
                        break;
                }
            });
        }
    }

    importBCUpload(): void {
        this.showBCUploadConfirmDialog = false;
        this.isUploadDisabled = true;
        this.showprogressbar = true;
        this._drawerService.spinnerLoad(true);
        const fileUploadRequest = this.getFileDtoRequest();
        this._fileService.uploadFile(fileUploadRequest).subscribe((event: HttpEvent<any>) => {
            switch (event.type) {
                case HttpEventType.Sent:
                    break;
                case HttpEventType.ResponseHeader:
                    this.uploadResponse(event.status);
                    break;
                case HttpEventType.UploadProgress:
                    this.progress = Math.round(event.loaded / event.total * 100);
                    break;
                case HttpEventType.Response:
                    break;
            }
        });
    }

    cancelBCUpload(): void {
        this.showBCUploadConfirmDialog = false;
    }

    uploadResponse(status) {
        this.isUploadDisabled = false;
        this.progress = 0;
        if (status === 200) {
            this.uploadFailed = false;
            if (this.uploaderTitle === APP_CONSTANTS.ADD_MULTIPLE_USERS) {
                this.getFielImportStatus(FileTypeEnum.ClientUser);
                this._adminClientUsersService.refreshTable();

            }
            if (this.uploadedFileType == this.fileTypeEnum.BusinessComponent) {
                this._businessComponentService.triggerRefresh();
                //this._toastrService.setSuccessMessage(`${this.uploadedFile.name} has been imported.`)
            }

            else {
                if (this.uploadedFileType !== this.fileTypeEnum.Employee && this.uploadedFileType !== this.fileTypeEnum.Project && !this.isClientManager) {
                    this._toastrService.setSuccessMessage(`${this.uploadedFile.name} has been imported.`);
                }
                else if (this.isClientManager) {
                    this._toastrService.setSuccessMessage(`${this.uploadedFile.name} has been uploaded.`);
                }
            }
            this.closeFileUploader(false);
            this._drawerService.spinnerLoad(false);
        } else {
            this.uploadFailed = true;
            this._drawerService.spinnerLoad(false);
            if (!this.isClientManager) {
                this._toastrService.setErrorMessage(`Unable to import ${this.uploadedFile.name}. Please try again.`);
            }
            else {
                this._toastrService.setErrorMessage(`Unable to upload ${this.uploadedFile.name}. Please try again.`);
            }
        }

    }

    getFielImportStatus(fileType: number): void {
        switch (fileType) {
            case FileTypeEnum.ClientUser:
                this._toastrService.setSuccessMessage(APP_CONSTANTS.ADD_MULTIPLE_USERS_MESSAGE);
                break;
        }
    }

    closeFileUploader(val: boolean): void {
        this.progress = 0;
        this._drawerService.closeRightSideDrawer(val);

    }

    download(downloadTemplate: string) {
        //this.generateSpinner(true);
        var lastIndex = downloadTemplate.lastIndexOf(".")
        this._fileService.download(downloadTemplate).subscribe(data => {
            let extention = '.' + downloadTemplate.split('/').pop().split('.').pop();
            extention = extention === ".msg" ? '.zip' : extention;
            let fileName = downloadTemplate.substring(0, lastIndex);
            this._fileService.saveBlobToFile(data, `${fileName}${extention}`);
            // this.generateSpinner(false);
        });
    }

    generateSpinner(spin: boolean) {
        this._drawerService.spinnerLoad(spin);
        this.fileUploader.nativeElement.disabled = spin;
    }

    onDocumentEvent(isDelete: boolean): void {
        this.generateSpinner(isDelete);
    }

    openContemporaneousDocInfo() {
        window.open('assets/TechnicalDocumentationReferenceSheet.pdf', '_blank').focus();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => {
            if (subscription) {
                subscription.unsubscribe();
            }
        });
    }

    updateShowFileImportSection(showFileImportSection: boolean) {
        this.showFileImportSection = showFileImportSection;
    }
}

